import styles from './site-footer.module.scss';
import React from "react";

import Icons from "@dblimp/icomoon";
import navigationDefinitions from "../../schemas/definitions/navigation-schema.json";

export interface SiteFooterProps {
  name?: string;
  classes?: string;
}

const navDefinitions = (navigationDefinitions as any).navigation as Record<
  string,
  { to?: string; href?: string; icon?: string; label?: string; name?: string; handle?: string }
>;

/** Redes sociales (socialNets → external `href`). */
const socialItems = ((navigationDefinitions as any).socialNets as string[])
  .map((key) => navDefinitions[key])
  .filter((entry) => entry && entry.href);

/**
 * Pie de página: redes sociales (navigation-schema) + logotipos de marca.
 */
export default class SiteFooter extends React.Component<SiteFooterProps> {
  static jsClass = "SiteFooter";
  static defaultProps: Partial<SiteFooterProps> = {
    name: "mbFooter",
  };

  render(): React.ReactNode {
    const { classes } = this.props;

    return (
      <footer className={styles['mb-footer'] + (classes ? ' ' + classes : '')}>
        <div className={styles['mb-wrap']}>
          <div className={styles['mb-footer__grid']}>
            <div className={styles['mb-footer__main']}>
              <h2 className={styles['mb-footer__title']}>
                Visita nuestras redes sociales
              </h2>
              <div className="row row-cols-2 g-4">
                {socialItems.map((entry) => (
                  <a
                    className={styles['mb-footer__social'] + ' col'}
                    key={entry.name}
                    href={entry.href}
                    target="_blank"
                    rel="noreferrer noopener">
                    <span className={styles['mb-footer__icon']}>
                      {entry.icon && <Icons icon={entry.icon} size={56} />}
                    </span>
                    <span className={styles['mb-footer__social-name']}>
                      {entry.label}
                    </span>
                    <span className={styles['mb-footer__social-handle']}>
                      {entry.handle ?? entry.name}
                    </span>
                  </a>
                ))}
              </div>
            </div>

            <div className={styles['mb-footer__brand']}>
              <img
                className={styles['mb-footer__logo']}
                src="/assets/design/logo.png"
                alt="MANGIBONE"
              />
              <img
                className={styles['mb-footer__pinos']}
                src="/assets/brand/los-pinos.png"
                alt="Quesería Los Pinos"
              />
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
